module.exports = __webpack_public_path__ + "flags.9c74e172f87984c48ddf.png";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/images/flags.png
// module id = ../../../../../src/assets/semantic/themes/default/assets/images/flags.png
// module chunks = styles